export const types = {
  GET: 'GET_MAINHUB_CONFIG',
};

export const mainHubConfigReducer = (state = [], action) => {
  switch (action.type) {
    case types.GET:
      return action.payload;
    default:
      return state;
  }
};
